
const Constants = {
    labels : {
        name_surname:"Nome e Cognome",
        ragone_sociale:"Ragione Sociale"
    },
    validation:{
        required:"Campo Obbligatorio",
        invalid_phone:"Numero di cellulare non valido"
    }
}

export default Constants;